import React from 'react';
import { siteConfig } from '../config/siteConfig';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full bg-brand-cream py-24 md:py-40 overflow-hidden" data-id="element-205">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-206">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-center" data-id="element-207">
          {/* Left Column - Parallax Image */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/2 h-[400px] md:h-[600px] rounded-2xl overflow-hidden relative" data-id="element-208">
            <img src={siteConfig.problem.image} alt="Med spa treatment" className="w-full h-full object-cover object-center" data-id="element-209" />
            <div className="absolute inset-0 bg-brand-navy/10 mix-blend-multiply" data-id="element-210"></div>
          </motion.div>

          {/* Right Column - Copy */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/2" data-id="element-211">
            <span className="text-brand-navy font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-212">
              {siteConfig.problem.eyebrow}
            </span>
            <h2 className="font-heading text-3xl md:text-[48px] font-bold text-brand-navy mb-8 leading-tight" data-id="element-213">
              {siteConfig.problem.headline}
            </h2>

            <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed font-light" data-id="element-214">
              {siteConfig.problem.paragraphs.map((p, idx) => <p key={idx} data-id="element-215">{p}</p>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}